import type { PartialBy } from '@lemonade-hq/ts-helpers';
import type { StyleRule } from '@vanilla-extract/css';
import type { ConfigConditions } from 'rainbow-sprinkles/dist/declarations/src/types';
import type { Simplify } from 'type-fest';

export const BREAKPOINTS = {
  sm: 0,
  md: 511,
  lg: 1104,
  xl: 1312,
} as const satisfies Record<string, number>;

export type Breakpoints = keyof typeof BREAKPOINTS;

export type ResponsiveValues<ResponsiveValueType> = Simplify<
  PartialBy<Record<Breakpoints, ResponsiveValueType>, 'lg' | 'md' | 'xl'>
>;

export const MEDIA_TOKEN = '@media';
type MediaQuery = Omit<StyleRule, typeof MEDIA_TOKEN>;

const MEDIA_QUERIES = {
  sm: `screen and (min-width: ${BREAKPOINTS.sm}px)`,
  md: `screen and (min-width: ${BREAKPOINTS.md}px)`,
  lg: `screen and (min-width: ${BREAKPOINTS.lg}px)`,
  xl: `screen and (min-width: ${BREAKPOINTS.xl}px)`,
} as const satisfies ResponsiveValues<string>;

export function mediaQueries(
  props: Partial<ResponsiveValues<MediaQuery>>,
): Record<typeof MEDIA_TOKEN, Record<string, MediaQuery>> {
  return {
    [MEDIA_TOKEN]: {
      ...(props.sm != null ? { [MEDIA_QUERIES.sm]: props.sm } : {}),
      ...(props.md != null ? { [MEDIA_QUERIES.md]: props.md } : {}),
      ...(props.lg != null ? { [MEDIA_QUERIES.lg]: props.lg } : {}),
      ...(props.xl != null ? { [MEDIA_QUERIES.xl]: props.xl } : {}),
    },
  };
}

export const SPRINKLES_RESPONSIVE_CONDITIONS = {
  conditions: {
    sm: {},
    md: { [MEDIA_TOKEN]: MEDIA_QUERIES.md },
    lg: { [MEDIA_TOKEN]: MEDIA_QUERIES.lg },
    xl: { [MEDIA_TOKEN]: MEDIA_QUERIES.xl },
  },
  defaultCondition: 'sm' as const,
} satisfies {
  readonly conditions: ConfigConditions;
  readonly defaultCondition: keyof ConfigConditions;
};
